import type { Divider } from "@sorcery/cms";

export const SanityDivider = ({ value }: { value: Divider }) => {
  const size = value.size;

  return (
    <div
      className={
        size === "Small"
          ? "py-4"
          : size === "Medium"
            ? "py-8"
            : size === "Large"
              ? "py-12"
              : // default
                "py-4"
      }
    />
  );
};
